import {
  Avatar,
  Burger,
  Button,
  Divider,
  Group,
  Indicator,
  Popover,
  Text,
} from "@mantine/core";
import { IconBell, IconLogout, IconSettings } from "@tabler/icons-react";
import "./MainHeader.scss";
import CustomLogo from "../../Logos/CustomLogo";
import { useDisclosure } from "@mantine/hooks";
import NotificationDrawer from "../../NotificationDrawer/NotificationDrawer";
import { useEffect, useState } from "react";
import ClientStatusBadge from "../ClientStatusBadge/ClientStatusBadge";
import { useNavigate } from "react-router-dom";
import { useNotificationStore } from "@/components/NotificationDrawer/store/notificationStore";
import { AppRoutes } from "@/constants.ts";

interface MainHeaderProps {
  opened: boolean;
  toggle: () => void;
  organizer?: boolean;
}

/**
 *
 * @param opened a boolean that determines if the navbar is open or closed
 * @returns a header component that contains the burger menu
 */
const MainHeader = ({ opened, toggle, organizer }: MainHeaderProps) => {
  const { hasNewNotifications } = useNotificationStore();

  const personalInfoString = localStorage.getItem("personalInfo");
  const personalInfo = personalInfoString ? JSON.parse(personalInfoString) : {};

  const [openedNotif, { open: openNotif, close: closeNotif }] =
    useDisclosure(false);

  const navigate = useNavigate();

  const businessInfo = JSON.parse(
    (localStorage.getItem("businessInfo") as string) || "{}"
  );

  const logoUrl = sessionStorage.getItem("logoUrl");

  const [loader, setLoader] = useState(true);

  const getInitials = (firstName: string, lastName: string) => {
    return firstName?.charAt(0) + lastName?.charAt(0);
  };

  // Loader effect for logo
  useEffect(() => {
    if (logoUrl !== "" && logoUrl !== null && logoUrl !== "undefined") {
      setLoader(false);
    }
  }, [logoUrl]);

  return (
    <Group className="main-header-container" h="100%" px="md">
      <NotificationDrawer opened={openedNotif} close={closeNotif} />
      {!organizer && (
        <Burger opened={opened} onClick={toggle} hiddenFrom="sm" size="sm" />
      )}
      {!loader && (
        <CustomLogo customUrl={logoUrl as string} isSmall isCustom={true} />
      )}
      <Group className="header" justify="space-between" style={{ flex: 1 }}>
        <h1 className="welcome-message">{businessInfo?.businessName}</h1>
        <Group className="status-container">
          <div className="return-status">
            <h3 className="return-status-text">Client Status:</h3>
            <ClientStatusBadge status={personalInfo?.status} />
          </div>
        </Group>
      </Group>

      {/* Icons only visible on mobile */}
      <Group className="icons">
        <Popover
          zIndex={10000}
          width={300}
          position="bottom"
          withArrow
          shadow="md"
        >
          <Popover.Dropdown
            className="todolist-popover"
            style={{ backgroundColor: "#fff", padding: "0rem" }}
          >
            <h2 className="todolist-label">Your To Do List</h2>
            <p className="info">
              You'll need to complete the following steps in order for us to
              process your return
            </p>
          </Popover.Dropdown>
        </Popover>
      </Group>

      <button className="notification-button" onClick={openNotif}>
        <Indicator inline disabled={!hasNewNotifications} color="red" size={12}>
          <IconBell size={30} />
        </Indicator>
      </button>
      <Popover
        position="bottom"
        withArrow
        shadow="md"
        offset={{ crossAxis: -120 }}
      >
        <Popover.Target>
          <div className="profile-button">
            <Avatar radius="xl" size="md" color="orange" variant="filled">
              {getInitials(personalInfo?.firstName, personalInfo?.lastName)}
            </Avatar>
          </div>
        </Popover.Target>
        <Popover.Dropdown w={300}>
          <div>
            {!organizer && (
              <>
                <div className="dropdown-item">
                  <Button
                    variant="transparent"
                    onClick={() => {
                      navigate(AppRoutes.settings);
                    }}
                    leftSection={<IconSettings size={20} />}
                    w="100%"
                    className="dropdown-item"
                  >
                    <Text>Settings</Text>
                  </Button>
                </div>
                <Divider />
              </>
            )}

            <div className="dropdown-item">
              <Button
                variant="transparent"
                onClick={() => {
                  navigate(AppRoutes.logout);
                }}
                w="100%"
                leftSection={<IconLogout size={20} color="red" />}
                className="dropdown-item"
              >
                <Text c="red">Logout</Text>
              </Button>
            </div>
          </div>
        </Popover.Dropdown>
      </Popover>
    </Group>
  );
};

export default MainHeader;
